/* unplugin-vue-components disabled */import script from "./check.vue?vue&type=script&setup=true&lang=js"
export * from "./check.vue?vue&type=script&setup=true&lang=js"

import "./check.vue?vue&type=style&index=0&id=1b6d5cf2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6d5cf2"]])

export default __exports__